module.exports = __webpack_public_path__ + "static/media/pill-eliquis.3bc0f62e.svg";